import ReactDOM from 'react-dom/client';
import { useMemo } from 'react';
import { RouterProvider, createBrowserRouter, useRouteError, Outlet, useLocation } from 'react-router-dom';
import { Header } from 'react-frontier';
import { initReactI18next, useTranslation } from 'react-i18next';
import { TitleProvider } from './components/Hooks';
import resourcesToBackend from "i18next-resources-to-backend";
import i18n from 'i18next';

// import './style/public.scss'
import 'frontier-css/css/frontier.css';
import 'frontier-css/css/icons.css';
import PaymentCharge from './screens/PaymentCharge';
import Landing from './screens/Landing';
import RequestPayment from './screens/RequestPayment';
import RequestResponse from './screens/RequestResponse';


i18n.use(initReactI18next).use(resourcesToBackend(async (l: string)=>{
	var lang = (await import(`./locale/public.${l}.json`)).default;
	return lang;
})).init({
	fallbackLng: 'es',
	interpolation: {
		escapeValue: false,
	}
});

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

var ErrorElement = ()=>{
	var { t } = useTranslation();
	const error = (useRouteError() as any);
	return <Header
		text={error.status}
		subtext={error.status===404 ? t('common.page_notfound') : t('common.unexpected_error', { code: error.status })}
		style={{ fontSize: 100 }}
		subheaderStyle={{ fontSize: 20 }}
		containerStyle={{ marginTop: 20 }}
	/>
}

var Site = (props: { outlet: JSX.Element })=>{
	var { t } = useTranslation();
	return <div style={{ paddingBottom: 50 }}>
		<TitleProvider suffix={t('common.site')}>
			<div style={{ paddingTop: 0 }}>
				{props.outlet}
			</div>
		</TitleProvider>
	</div>
}

const Router = createBrowserRouter([{
	path: '/',
	errorElement: <Site outlet={<ErrorElement />} />,
	element: <Site outlet={<Outlet />} />,
	children: [
		{ path: '/', element: <Landing /> },
		{ path: '/error', element: <PaymentCharge error /> },
		{ path: '/request/:hash', element: <RequestPayment /> },
		{ path: '/request/:hash/response', element: <RequestResponse /> },
		{ path: '/:hash', element: <PaymentCharge /> },
	]
}]);

var Root = ()=>{
	return <RouterProvider router={Router} />
}

root.render(<Root />);